import { AgentLeaderboardSchema } from '@kilat/shared';

import { createRepo } from './_base.js';

/**
 * Weekly agent leaderboard (backend PR #187) — a PUBLIC-read aggregate doc at
 * `leaderboards/{platformBrandId}/weeks/{isoWeekKey}` whose `entries` array the
 * `leaderboardOnSignup` trigger keeps sorted DESC by `signupCount` and capped
 * at `LEADERBOARD_TOP_N`.
 *
 * The read path is therefore ONE bounded single-doc `snapshot` on the
 * current-week doc — never a collection scan. The `weeks` sub-collection id is
 * the ISO week key from `currentWeekKey()` (single-sourced with the trigger via
 * the shared `isoWeekKey` helper).
 */
export function leaderboardRepoFor(brandId: string) {
  return createRepo({
    path: `leaderboards/${brandId}/weeks`,
    schema: AgentLeaderboardSchema,
    name: `leaderboards/${brandId}/weeks`,
  });
}
